<template>
    <b-modal ref="mdlPaiDomiciliareAccessiCategorie" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="sm">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Codice</label>
                <b-form-input v-model="jsonData.codice" required></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Descrizione</label>
                <b-form-input v-model="jsonData.descrizione" required> </b-form-input>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button variant="outline-success" @click="onClickSave()">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    watch: {},
    data() {
        return {
            pathResource: "/rsapaidomiciliareaccessicategorie",
            id: null,
            title: null,
            listKey: 0,
            jsonData: {
                id: null,
                descrizione: null,
                codice: null,
            },
        };
    },
    mounted() {},
    methods: {
        show(id = null) {
            let me = this;
            this.jsonData = { id: null, descrizione: null, codice: null };
            if (id) {
                me.id = id;
                me.loadData();
            }
            me.$refs.mdlPaiDomiciliareAccessiCategorie.show();
        },
        loadData() {
            let me = this;
            this.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, null);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        onCloseModal() {
            let me = this;
            me.$refs.mdlPaiDomiciliareAccessiCategorie.hide();
            me.$emit("onCloseModal");
        },
        onClickSave() {
            let me = this;
            this.saveResource(me.pathResource, me.jsonData, me.saveConfigurazioneAccessiCategorieSuccess, me.saveConfigurazioneAccessiCategorieError);
        },
        saveConfigurazioneParametriVitaliSuccess() {
            let me = this;
            me.$refs.mdlPaiDomiciliareAccessiCategorie.hide();
            this.$emit("afterSaveAccessiCategoria");
            me.$bvToast.toast("Salvataggio avvvenuto con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });
            console.log("ciao");
        },
        saveConfigurazioneParametriVitaliError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
    },
};
</script>
